export default function ScopeSection() {
  return (
    <section className="w-full bg-white py-10">
      <div className="max-w-[880px] mx-auto px-4 md:px-6">
        <div className="bg-[#fefce8] rounded-xl border-l-4 border-primary p-6">
          <h3 className="text-lg font-bold text-secondary mb-3">
            Honest Scope
          </h3>
          <p className="text-sm text-[#374151] leading-relaxed">
            We repair hardware on existing windows and doors. We do not replace entire windows, frames, or perform installations. For replacement or new installations, we refer you to licensed Florida contractors at no cost.
          </p>
        </div>
      </div>
    </section>
  );
}